<template>
  <div class="block-chain-create-retrieval">
    <detail-section title="新建链上数据">
      <el-form
        ref="formDate"
        :model="formDate"
        :rules="rules"
        :label-width="`${adaptationVars.formLabelWidth}px`"
        class="demo-ruleForm"
        label-position="left"
      >
        <el-form-item label="属性定义" prop="abe_policy" class="form-item-character">
          <div class="policy-wrap">
            <div class="policy-select">
              <el-select v-model="formDate.attributes" placeholder="请选择属性集合">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  @click.native="attributesChange(item.label)"
                >
                </el-option>
              </el-select>

              <el-select
                v-model="formDate.character"
                class="character"
                placeholder="请选择属性字符"
              >
                <el-option
                  v-for="item in characterType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  @click.native="characterChange(item.label)"
                >
                </el-option>
              </el-select>
            </div>
            <div class="policy-display">
              <el-input v-model="formDate.abe_policy" placeholder=""></el-input>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="关键字" prop="key">
          <el-input
            v-model="formDate.key"
            placeholder="关键字只支持中文，多个关键字用,隔开"
          ></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="data">
          <el-input
            v-model="formDate.data"
            type="textarea"
            placeholder="请输入"
            :rows="10"
          ></el-input>
        </el-form-item>

        <el-form-item style="text-align: right;">
          <el-button
            v-if="$utils.hasAuth($store, auth.blockchain.checkDetail.createOnChainData.reset)"
            @click="resetForm('formDate')"
            >重置</el-button
          >&emsp;
          <el-button
            v-if="$utils.hasAuth($store, auth.blockchain.checkDetail.createOnChainData.create)"
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="submitForm('formDate')"
            >新建</el-button
          >
        </el-form-item>
      </el-form>
    </detail-section>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
import auth from '@/auth/index'

export default {
  name: 'Index',
  components: {},
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 85
  },
  data() {
    return {
      characterType: [
        {
          label: '(',
          value: '('
        },
        {
          label: ')',
          value: ')'
        },
        {
          label: ' AND ',
          value: ' AND '
        },
        {
          label: ' OR ',
          value: ' OR '
        }
      ],
      formDate: {
        attributes: '',
        character: '',
        abe_policy: '', //策略表达式
        key: '', //关键字
        data: ''
      },
      rules: {
        abe_policy: [
          { required: true, message: '请输入策略表达式', trigger: 'blur' }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        key: [
          { required: true, message: '请输入关键字', trigger: 'blur' }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        data: [
          {
            required: true,
            message: '请输入文本',
            trigger: 'blur'
          }
        ]
      },
      options: [],
      info: {},
      auth: auth,
      adaptationVars: {
        formLabelWidth: 85
      },
      chainId: '',
      loading: false
    }
  },
  watch: {
    '$store.state.computing.chainId': {
      deep: true,
      handler(val) {
        this.chainId = val
      }
    }
  },
  mounted() {
    this.$apis.chain
      .getAttributeList()
      .then(res => {
        this.options = res.data.map(item => {
          return { label: item, value: item }
        })
      })
      .catch(err => {
        this.disabled = false
        return
      })
    //this.info = JSON.parse(this.$route.query.detail)
    this.chainId = this.$store.state.computing.chainId
  },
  methods: {
    attributesChange(val) {
      this.formDate.abe_policy += val
    },
    characterChange(val) {
      this.formDate.abe_policy += val
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true
          const userID = JSON.parse(localStorage.getItem('userID'))
          let params = {}
          params.abe_policy = this.formDate.abe_policy
          params.data = this.formDate.data
          params.key_words = this.formDate.key
          params.chain_id = this.chainId
          params.user_id = userID

          this.$apis.chain
            .uploadData(params)
            .then(res => {
              this.$message.success('数据上链成功')
              this.handleCancel()
            })
            .catch(err => {
              return
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    refresh() {}
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('block-chain-create-retrieval', (), ());
.block-chain-create-retrieval {
  @include adaptation(
    (
      --block-chain-create-retrieval-form-width: 614px,
      --block-chain-create-retrieval-policy-select-item-margin-left: 16px,
      --block-chain-create-retrieval-policy-display-margin-top: 16px,
      --block-chain-create-retrieval-detail-section-padding: 4px 0
    )
  );

  .el-form {
    width: var(--block-chain-create-retrieval-form-width);
  }

  .cbaas-detail-section {
    padding: var(--block-chain-create-retrieval-detail-section-padding);
  }

  .policy-wrap {
    display: flex;
    flex-direction: column;

    .policy-select {
      display: flex;

      .el-select {
        flex: 1;
      }

      :not(:first-child) {
        margin-left: var(--block-chain-create-retrieval-policy-select-item-margin-left);
      }
    }

    .policy-display {
      margin-top: var(--block-chain-create-retrieval-policy-display-margin-top);
    }
  }
}
</style>
